import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;

const headers = () => ({
  headers: { Authorization: `Bearer ${AuthService.getToken()}` },
});

const unwrap = (data) => (Array.isArray(data) ? data : data?.$values ?? []);

const AttendanceService = {
  getTodayAttendance: (userId) =>
    axios.get(`${BASE}/Attendance/Today/${userId}`, headers()).then((r) => r.data),

  getMyHistory: (userId, from, to) =>
    axios
      .get(`${BASE}/Attendance/MyHistory/${userId}`, {
        ...headers(),
        params: { from: from.toISOString(), to: to.toISOString() },
      })
      .then((r) => unwrap(r.data)),

  /** Single day (pass date) or range (pass from + end dates). */
  getTeamAttendance: (clientId, { date, from, to } = {}) =>
    axios
      .get(`${BASE}/Attendance/Team/${clientId}`, {
        ...headers(),
        params:
          from && to
            ? { from: from.toISOString(), to: to.toISOString() }
            : { date: (date || new Date()).toISOString() },
      })
      .then((r) => unwrap(r.data)),

  checkIn: (userId, location = '') =>
    axios
      .post(`${BASE}/Attendance/CheckIn/${userId}`, null, {
        ...headers(),
        params: { location },
      })
      .then((r) => r.data),

  checkOut: (userId, location = '') =>
    axios
      .post(`${BASE}/Attendance/CheckOut/${userId}`, null, {
        ...headers(),
        params: { location },
      })
      .then((r) => r.data),

  markLeave: (userId, date, status, notes = '') =>
    axios
      .post(`${BASE}/Attendance/MarkLeave/${userId}`, null, {
        ...headers(),
        params: { date: date.toISOString(), status, notes },
      })
      .then((r) => r.data),

  // Leave Requests
  getMyLeaves: (userId) =>
    axios.get(`${BASE}/LeaveRequest/MyLeaves/${userId}`, headers()).then((r) => unwrap(r.data)),

  getPendingLeaves: (clientId) =>
    axios.get(`${BASE}/LeaveRequest/Pending/${clientId}`, headers()).then((r) => unwrap(r.data)),

  createLeave: (dto) =>
    axios.post(`${BASE}/LeaveRequest/Create`, dto, headers()).then((r) => r.data),

  approveLeave: (id, approvedById, note = '') =>
    axios
      .put(`${BASE}/LeaveRequest/Approve/${id}`, null, {
        ...headers(),
        params: { approvedById, note },
      })
      .then((r) => r.data),

  rejectLeave: (id, approvedById, note = '') =>
    axios
      .put(`${BASE}/LeaveRequest/Reject/${id}`, null, {
        ...headers(),
        params: { approvedById, note },
      })
      .then((r) => r.data),

  deleteLeave: (id) =>
    axios.delete(`${BASE}/LeaveRequest/Delete/${id}`, headers()).then((r) => r.data),
};

export default AttendanceService;
